import React from 'react';
import Form from 'components/Form';
import { startSignUpSubmit, resolveSignUpSubmit } from 'modules/SignUp/actions';
import useSignUpStep from 'modules/SignUp/hooks/useSignUpStep';
import { UserRoleType } from 'types/global';
import UserInfoStep from './UserInfoStep';
import UserCompanyInfoStep from './UserCompanyInfoStep';

interface SignUpFormProps {
  userRole: UserRoleType;
}

const SignUpForm: React.FC<SignUpFormProps> = ({ userRole }): JSX.Element => {
  const { formStep, setInitialFormStepHandler } = useSignUpStep();
  return (
    <Form
      startSubmitAction={startSignUpSubmit().type}
      resolveSubmitAction={resolveSignUpSubmit().type}
      setPayload={(action: object, payload: any) => ({
        ...action,
        payload: {
          ...payload,
          userRole,
        },
      })}
    >
      {(formProps: any) => {
        const {
          form,
          values,
          hasValidationErrors,
          submitting,
          submitError,
          submitErrors,
        } = formProps;
        return (
          <>
            {(() => {
              switch (formStep) {
                case 1:
                  return (
                    <UserInfoStep
                      userRole={userRole}
                      allFomValues={values}
                      hasValidationErrors={hasValidationErrors}
                      handleSubmit={form.submit}
                      submitting={submitting}
                      submitError={submitError}
                    />
                  );
                case 2:
                  return (
                    <UserCompanyInfoStep
                      userRole={userRole}
                      signUpInitialStepHandler={setInitialFormStepHandler}
                      submitting={submitting}
                      submitError={submitError}
                      submitErrors={submitErrors}
                      form={form}
                    />
                  );
                default:
                  return null;
              }
            })()}
          </>
        );
      }}
    </Form>
  );
};

export default SignUpForm;
